<script>
import Layout from "../../layout/mainLayout";
import PageHeader from "@/components/page-header";
import { required, email } from "vuelidate/lib/validators";
import appConfig from "@/app.config";
import axios from 'axios';
/*
 * Edit Admin
 */
export default {
  page: {
    title: "Edit Admin",
    meta: [
      {
        name: "description",
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      name: "Edit Admin",
      title: "Edit Admin",
      items: [
        {
          text: "Admins",
          href: "/admins",
        },
      ],
      form: {
        name: "",
        email: "",
        mobile_phone: "",
        password: "",
        isActive: 0,
        permissions: [],
      },
      errors: null,
      submitted: false,
      pending: false,
      permissionsList: [],
      select_all_permissions: false,
      currrentAdmin: {},
      authUser: {},
      isValidMobileNumber: true,
    };
  },
  validations: {
    form: {
      email: { required, email },
      name: { required },
      mobile_phone: { required },
    },
  },
  methods: {
    async getCurrentAdmin() {
      let that = this;
      await axios
        .get(appConfig.admins.edit + this.$route.params.id)
        .then(function (response) {
          that.currrentAdmin = response.data.admin;
          that.currrentAdmin["permissions"] = response.data.permissions;
          that.form = that.currrentAdmin;
          that.form.password = ""; // don't remove this
        });
    },
    validateMobileNumber() {
      const validationRegex = /^\d{10}$/;
      if (this.form.mobile_phone.match(validationRegex)) {
        this.isValidMobileNumber = true;
      } else {
        this.isValidMobileNumber = false;
      }
    },
    selectAll() {
      let selected = [];
      this.select_all_permissions = !this.select_all_permissions;
      if (
        this.select_all_permissions == 1 ||
        this.select_all_permissions == true
      ) {
        this.permissionsList.forEach(function (permission) {
          selected.push(permission);
        });
      }
      this.form.permissions = selected;
    },
    unSelectAll() {
      if (this.form.permissions.length === this.permissionsList.length) {
        this.select_all_permissions = false;
      }
    },
    async getPermissionsList() {
      let that = this;
      await axios
        .get(appConfig.permissions.list)
        .then(function (response) {
          that.permissionsList = response.data.permissions;
        });
    },
    async updateUser() {
      let that = this;
      that.$v.$touch();

      if (that.$v.$invalid || !this.isValidMobileNumber) {
        window.scrollTo(0, 0);
        return;
      } else {
        that.submitted = true;
        let formData = new FormData();

        formData.append("name", that.form.name);
        formData.append("email", that.form.email);
        formData.append("mobile_phone", that.form.mobile_phone);
        formData.append("password", that.form.password);
        formData.append("isActive", that.form.isActive);
        formData.append("permissions", that.form.permissions);

        await axios
          .post(
            appConfig.admins.update + that.$route.params.id,
            formData,
            that.headers
          )
          .then(function (res) {
            console.log(res);
            that.submitted = false;
            that.$iziToast.success({
              message: "Update Successfully!",
              position: "bottomCenter",
            });
            that.$router.push({ name: "Admins" });
          })
          .catch(function (error) {
            that.submitted = false;
            if (error.response) {
              that.errors = error.response.data.errors;
              window.scrollTo(0, 0);
            }
          });
      }
    },
  },
  created() {
    this.authUser = this.$store.getters["auth/user"];
    this.pending = true;
    axios
      .all([this.getPermissionsList(), this.getCurrentAdmin()])
      .finally(() => (this.pending = false));
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card" id="error_area">
          <div class="card-body">
            <FormValidation :errors="errors" />

            <form class="needs-validation" @submit.prevent="updateUser">
              <fieldset :disabled="submitted || pending">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group mb-3">
                      <label for="name">Name</label>
                      <input
                        type="text"
                        v-model="form.name"
                        class="form-control"
                        id="name"
                        placeholder="Enter name"
                        :class="{ 'is-invalid': $v.form.name.$error }"
                      />
                      <div
                        v-if="!$v.form.name.required"
                        class="invalid-feedback"
                      >
                        Name is required
                      </div>
                    </div>
                    <div class="form-group mb-3">
                      <label for="email">Email</label>
                      <input
                        type="text"
                        v-model="form.email"
                        class="form-control"
                        id="email"
                        placeholder="Enter email"
                        :class="{ 'is-invalid': $v.form.email.$error }"
                      />
                      <div v-if="$v.form.email.$error" class="invalid-feedback">
                        <span v-if="!$v.form.email.required"
                          >Email is required</span
                        >
                        <span v-if="!$v.form.email.email"
                          >Email is invalid</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group mb-3">
                      <label for="userpassword">New Password</label>
                      <input
                        v-model="form.password"
                        type="text"
                        class="form-control"
                        id="userpassword"
                        placeholder="Enter new password"
                      />
                    </div>

                    <div class="form-group mb-3">
                      <label for="mobile_phone">Mobile Number</label>
                      <input
                        v-model="form.mobile_phone"
                        type="text"
                        class="form-control"
                        id="mobile_phone"
                        placeholder="Enter Mobile Number"
                        @keyup="validateMobileNumber()"
                        :class="{ 'is-invalid': $v.form.mobile_phone.$error }"
                      />
                      <div
                        v-if="!$v.form.mobile_phone.required"
                        class="invalid-feedback"
                      >
                        Mobile Number is required
                      </div>
                      <div v-if="!isValidMobileNumber">
                        <span> Invalid Mobile Number</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12" v-if="$can('active_admin')">
                    <div class="custom-control custom-checkbox isActiveCheck">
                      <input
                        v-model="form.isActive"
                        type="checkbox"
                        class="custom-control-input"
                        id="isActive"
                      />
                      <label class="custom-control-label" for="isActive"
                        >Active Account</label
                      >
                    </div>
                  </div>
                </div>
                <!-- row -->

                <div
                  class="row"
                  v-if="$can('admin_permissions') && permissionsList.length > 0"
                >
                  <div class="col-lg-12">
                    <hr />

                    <h6 class="mt-0"><strong>Permissions</strong></h6>

                    <div class="custom-control custom-checkbox">
                      <input
                        @click="selectAll"
                        type="checkbox"
                        class="custom-control-input"
                        id="select_all"
                        :checked="
                          form.permissions.length === permissionsList.length
                        "
                      />
                      <label class="custom-control-label" for="select_all"
                        >All</label
                      >
                    </div>

                    <div class="mt-2 permissions">
                      <div
                        v-for="permission in permissionsList"
                        :key="permission"
                        class="col-lg-3 custom-control custom-checkbox"
                      >
                        <input
                          v-model="form.permissions"
                          type="checkbox"
                          class="custom-control-input"
                          :value="permission"
                          :id="permission"
                          @click="unSelectAll"
                        />
                        <label class="custom-control-label" :for="permission">{{
                          permission.replaceAll("_", " ")
                        }}</label>
                      </div>
                    </div>
                  </div>
                  <!-- col-lg-12 -->
                </div>

                <div class="col-lg-12 mt-4 text-right">
                  <button
                    class="btn btn-primary w-md waves-effect waves-light"
                    type="submit"
                  >
                    <span
                      v-show="submitted || pending"
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span v-show="!submitted && !pending">Update</span>
                  </button>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped>
.permissions .custom-control-label {
  text-transform: capitalize;
}
.permissions .custom-checkbox {
  display: inline-block;
}
</style>
